import { Card, CardContent, Skeleton, Typography } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';

export function SalesPersonSkeleton() {
  return (
    <>
      <Typography
        variant="h2"
        component="div"
        className="pt-4 mb-4"
        sx={{ flexGrow: 1 }}>
        <Skeleton animation="wave" width={150} height={40} />
      </Typography>

      <div className="d-flex">
        <Skeleton className="mb-3 me-3" animation="wave" width={150} height={50} />
      </div>

      <Row className='mb-4'>
        <Col md={6} xxl={3}>
          <Card sx={{ minHeight: 143 }} className='mb-4'>
            <CardContent>
              <div className="d-flex flex-row align-items-center mb-3">
                <Skeleton className='me-3' variant="circular" width={40} height={40} />
                <Typography
                  variant="h5"
                  component="div">
                  <Skeleton animation="wave" width={100} />
                </Typography>
              </div>
              <Typography
                variant="h6"
                component="div" className='me-2'>
                <Skeleton animation="wave" width={150} />
              </Typography>
              <Typography
                variant="h6"
                component="div">
                <Skeleton animation="wave" width={150} />
              </Typography>
            </CardContent>
          </Card>
        </Col>

        <Col md={6} xxl={3}>
          <Card sx={{ minHeight: 143 }} className='mb-4'>
            <CardContent>
              <div className="d-flex flex-row align-items-center mb-3">
                <Skeleton className='me-3' variant="circular" width={40} height={40} />
                <Typography
                  variant="h5"
                  component="div"
                  className="mb-3">
                  <Skeleton animation="wave" width={100} />
                </Typography>
              </div>
              <Typography
                variant="h6"
                component="div">
                <Skeleton animation="wave" width={150} />
              </Typography>
            </CardContent>
          </Card>
        </Col>

        <Col md={6} xxl={3}>
          <Card sx={{ minHeight: 143 }} className='mb-4'>
            <CardContent>
              <div className="d-flex flex-row align-items-center mb-3">
                <Skeleton className='me-3' variant="circular" width={40} height={40} />
                <Typography
                  variant="h5"
                  component="div"
                  className="mb-3">
                  <Skeleton animation="wave" width={100} />
                </Typography>
              </div>
              <Typography
                variant="h6"
                component="div">
                <Skeleton animation="wave" width={150} />
              </Typography>
              <Typography
                variant="h6"
                component="div">
                <Skeleton animation="wave" width={150} />
              </Typography>
            </CardContent>
          </Card>
        </Col>
        <Col md={6} xxl={3}>
          <Card sx={{ minHeight: 143 }} className='mb-4'>
            <CardContent>
              <div className="d-flex flex-row align-items-center mb-3">
                <Skeleton className='me-3' variant="circular" width={40} height={40} />
                <Typography
                  variant="h5"
                  component="div"
                  className="mb-3">
                  <Skeleton animation="wave" width={100} />
                </Typography>
              </div>
              <Typography
                variant="h6"
                component="div">
                <Skeleton animation="wave" width={150} />
              </Typography>
              <Typography
                variant="h6"
                component="div">
                <Skeleton animation="wave" width={150} />
              </Typography>
            </CardContent>
          </Card>
        </Col>
      </Row>
      <div className="d-flex align-items-center mb-3 mb-xl-0">
        <div className='mb-3 mb-md-0'>
          <Skeleton animation="wave" width={150} height={50} />
        </div>
      </div>
      <div className='d-flex justify-content-end'>
        <Skeleton animation="wave" width={150} height={60} />
      </div>
      <Skeleton variant="rectangular" animation="wave" width='100%' height={650} />
    </>
  );
}

export default SalesPersonSkeleton;
